import { useI18n } from "../util/i18n";
import Pulse from "./Panel/Pulse";
import React from "react";
import { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../assets/css/custom.css";
import { getDashboard } from "../store/dashboard/dashboard.action";
import { Chart as ChartJS } from "chart.js/auto";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import dayjs from "dayjs";
import { useState } from "react";
import { getChart, getChartData } from "../store/dashboard/dashboard.action";
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = (props) => {
  const { t } = useI18n();
  const { dashboard, analytic, host, user } = useSelector(
    (state) => state.dashboard
  );

  const [type, setType] = useState("UserHost");
  const dispatch = useDispatch();

  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  const startDate = dayjs(firstDay).format("YYYY-MM-DD");
  const endDate = dayjs(lastDay).format("YYYY-MM-DD");

  const [sDate, setSDate] = useState(startDate);
  const [eDate, setEDate] = useState(endDate);
  const [analyticData, setAnalyticData] = useState([]);
  const [analyticUser, setAnalyticUser] = useState([]);
  const [analyticHost, setAnalyticHost] = useState([]);

  let label = [];
  let dataUser = [];
  let dataHost = [];
  let data = [];

  // Sade grafik: ince cizgi, yumusak dolgu, silik izgara, tamsayi eksen
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    interaction: { mode: "index", intersect: false },
    elements: { line: { borderWidth: 2.5, tension: 0.35 }, point: { radius: 0, hoverRadius: 5 } },
    scales: {
      x: { grid: { display: false }, ticks: { color: "#94A3B8", font: { size: 11 } } },
      y: { beginAtZero: true, grid: { color: "rgba(148,163,184,.15)" }, border: { display: false }, ticks: { color: "#94A3B8", precision: 0, font: { size: 11 } } },
    },
    plugins: {
      legend: { position: "top", align: "end", labels: { usePointStyle: true, boxWidth: 8, color: "#475569", font: { size: 12, weight: "600" } } },
      title: { display: false },
      tooltip: { backgroundColor: "#0F172A", padding: 10, cornerRadius: 8 },
    },
  };
  useEffect(() => {
    dispatch(getDashboard());
    dispatch(getChart(type, sDate, eDate));
    dispatch(getChartData(type, sDate, eDate));
  }, [dispatch]);

  useEffect(() => {
    setAnalyticData(analytic);
  }, [analytic]);

  useEffect(() => {
    setAnalyticUser(user);
  }, [user]);

  useEffect(() => {
    setAnalyticHost(host);
  }, [host]);

  if (analyticData?.length > 0) {
    if (type === "LiveHost" || type === "Revenue") {
      if (type === "LiveHost") {
        analyticData.map((data_) => {
          const newDate = data_._id;

          var date;
          if (newDate._id) {
            date = newDate?._id.split("T");
          } else {
            date = newDate.split("T");
          }

          date?.length > 0 && label.push(date[0]);

          data.push(data_.count);
        });
      } else {
        analyticData.map((data_) => {
          const newDate = data_?._id;

          const date = newDate?.split("T");

          // date?.length > 0 && label.push(date[0]);

          data.push(data_.dollar);
        });
      }
    }
    // analyticData.map((data_) => {
    //   const newDate = data_._id;

    //   var date;
    //   if (newDate._id) {
    //     date = newDate?._id.split("T");
    //   } else {
    //     date = newDate.split("T");
    //   }

    //   date?.length > 0 && label.push(date[0]);

    //   data.push(data_.count);
    // });
  }

  if (analyticUser?.length > 0 || analyticHost?.length > 0) {
    analyticUser.map((data_) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        date = newDate?._id.split("T");
      } else {
        date = newDate.split("T");
      }

      date?.length > 0 && label.push(date[0]);

      dataUser.push(data_.count);
    });
  }

  if (analyticHost?.length > 0) {
    analyticHost.map((data_) => {
      const newDate = data_._id;

      var date;
      if (newDate._id) {
        date = newDate?._id.split("T");
      } else {
        date = newDate.split("T");
      }

      // date?.length > 0 && label.push(date[0]);

      dataHost.push(data_.count);
    });
  }

  const chartData = {
    labels: label,
    datasets: [
      {
        label: "Kullanıcı",
        data: dataUser,
        fill: true,
        // fillOpacity: 1,
        // backgroundColor: "rgba(255, 99, 132, 0.1)",
        borderColor: "#6366F1",
        backgroundColor: "rgba(99,102,241,.12)",
        lineTension: 0.5,
      },

      {
        label: "Yayıncı",
        data: dataHost,
        fill: true,
        // fillOpacity: 0.9,
        // backgroundColor: "rgba(33, 150, 243, 0.169)",
        borderColor: "#F59E0B",
        backgroundColor: "rgba(245,158,11,.10)",
        lineTension: 0.5,
      },
    ],
  };

  const multiLineChartData = {
    labels: label,
    datasets: [
      {
        label: "User",
        data: data,
        fill: true,
        backgroundColor: "rgba(255, 99, 132, 0.1)",
        borderColor: "rgb(255, 99, 132)",
        lineTension: 0.5,
      },
      {
        label: "Host",
        data: data,
        fill: true,
        backgroundColor: "rgb(205,235,255,0.1)",
        borderColor: "#68B9F0",
        lineTension: 0.5,
      },
    ],
  };

  const defaultChart = {
    labels: label,
    datasets: [
      {
        label: type,
        data: data,
        fill: true,
        fillOpacity: 1,
        backgroundColor: "rgba(255, 99, 132, 0.1)",
        borderColor: "#6366F1",
        backgroundColor: "rgba(99,102,241,.12)",
        lineTension: 0.5,
      },
    ],
  };

  const otherChart = {
    labels: label,
    datasets: [
      {
        label: type,
        data: data,
        fill: true,
        fillOpacity: 1,
        backgroundColor: "rgba(255, 99, 132, 0.1)",
        // borderColor: "rgb(33, 150, 243)",
        borderColor: "rgb(255, 99, 132)",
        lineTension: 0.5,
      },
    ],
  };

  const handleAnalytic = (type) => {
    sessionStorage.removeItem("online");
    setSDate(startDate);
    setEDate(endDate);
    setType(type);

    dispatch(getChart(type, startDate, endDate));
  };

  //Apply button function for analytic
  const handleApply = (event, picker) => {
    if (type === "UserHost" || type === "LiveHost" || type === "Revenue") {
      picker.element.val(
        picker.startDate.format("YYYY-MM-DD") +
          " - " +
          picker.endDate.format("YYYY-MM-DD")
      );
      const dayStart = dayjs(picker.startDate).format("YYYY-MM-DD");

      const dayEnd = dayjs(picker.endDate).format("YYYY-MM-DD");

      setSDate(dayStart);
      setEDate(dayEnd);

      dispatch(getChart(type, dayStart, dayEnd));
      dispatch(getChartData(type, dayStart, dayEnd));
    }
  };

  //Cancel button function for analytic
  const handleCancel = (event, picker) => {
    picker.element.val("");
    dispatch(getChart(type, startDate, endDate));
    dispatch(getChartData(type, startDate, endDate));
  };

  const kpis = [
    { label: "Çevrimiçi kullanıcı", value: dashboard?.onlineUser || 0, to: "/admin/user" },
    { label: "Toplam kullanıcı", value: dashboard?.user || 0, to: "/admin/user" },
    { label: "Şu an yayında", value: dashboard?.liveHost || 0, to: "/admin/liveStreams" },
    { label: "Çevrimiçi yayıncı", value: dashboard?.onlineHost || 0, to: "/admin/host" },
  ];

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>{t("Panel")}</h4>
          <div className="sub">{t("AYVO · canlı yayın ve coin ekonomisi özeti")}</div>
        </div>
        <DateRangePicker
          initialSettings={{ autoUpdateInput: false }}
          onApply={handleApply}
          onCancel={handleCancel}
        >
          <input
            type="text"
            className="form-control"
            placeholder="Tarih aralığı seç"
            style={{ maxWidth: 210 }}
            readOnly
          />
        </DateRangePicker>
      </div>

      {/* Bugunun ozeti, canli durum, bekleyen isler ve listeler */}
      <Pulse />

      <div className="badu-bento">

        <div className="badu-tile span-3">
          <div className="badu-tile-head">
            <b>
              {type === "Revenue"
                ? "Gelir"
                : type === "LiveHost"
                ? "Canlı yayın"
                : "Yeni kullanıcı / yayıncı"}
            </b>
            <div className="btn-group btn-group-sm" role="group">
              {[
                { k: "UserHost", t: "Kullanıcı / Yayıncı" },
                { k: "LiveHost", t: "Canlı yayın" },
                { k: "Revenue", t: "Gelir" },
              ].map((b) => (
                <button
                  key={b.k}
                  type="button"
                  className="btn btn-sm"
                  onClick={() => handleAnalytic(b.k)}
                  style={{
                    background: type === b.k ? "#1E40AF" : "#FFFFFF",
                    color: type === b.k ? "#FFFFFF" : "#6B7280",
                    border: "1px solid #E8EBF0",
                    fontSize: 11.5,
                    fontWeight: 600,
                    padding: "4px 11px",
                  }}
                >
                  {b.t}
                </button>
              ))}
            </div>
          </div>
          <div className="badu-chart-wrap">
            <Line
              options={{ ...options, maintainAspectRatio: false }}
              data={
                type === "UserHost"
                  ? chartData
                  : type === "Revenue"
                  ? otherChart
                  : defaultChart
              }
            />
          </div>
        </div>

        <div style={{ display: "grid", gap: 14, gridAutoRows: "min-content" }}>
          <Link to="/admin/host" className="badu-tile">
            <p className="badu-lbl">Toplam yayıncı</p>
            <div className="badu-val">{dashboard?.host || 0}</div>
          </Link>
          <div className="badu-tile">
            <p className="badu-lbl">Toplam gelir</p>
            <div className="badu-val">
              {Number(dashboard?.revenue?.dollar || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              <span style={{ fontSize: 16, marginLeft: 2 }}>$</span>
            </div>
          </div>
          <Link to="/admin/hostRequest" className="badu-tile">
            <p className="badu-lbl">Bekleyen yayıncı başvurusu</p>
            <div className="badu-val">{dashboard?.hostRequest || 0}</div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getDashboard })(Dashboard);
